// Committed session history is mirrored to sessionStorage so it survives a
// reload or in-app navigation (scoped to the browser tab; cleared when the tab
// closes). Only `history` is persisted — restoring a half-scanned
// `current`/`pendingVial` after a reload would show stale state the scanner no
// longer knows about.
const HISTORY_STORAGE_KEY = 'rxScanStation.sessionHistory';

const isStoredSession = (s) =>
  s && typeof s === 'object' && typeof s.id === 'string' && s.rx && Array.isArray(s.vials);

// A session restored while its fulfill call was still in flight has an unknown
// outcome — the call may have succeeded server-side before the reload. Mark it
// 'unknown' (not 'failed': failed tells the operator to re-scan and commit
// again, which here could double-fulfill). Same idea for a label
// regeneration/print that was still in flight — there's no automatic retry,
// so a stuck 'regenerating'/'printing' chip would mislead the operator into
// thinking it's still working.
const rehydrateSession = (s) => ({
  ...s,
  ...(s.fulfillStatus === 'pending' ? { fulfillStatus: 'unknown', fulfillError: undefined } : {}),
  ...(s.labelStatus === 'regenerating' ? { labelStatus: 'unknown' } : {}),
  ...(s.printStatus === 'printing' ? { printStatus: 'unknown' } : {}),
});

export const loadStoredHistory = () => {
  try {
    const raw = sessionStorage.getItem(HISTORY_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isStoredSession).map(rehydrateSession);
  } catch {
    return [];
  }
};

export const saveStoredHistory = (history) => {
  try {
    sessionStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(history));
  } catch {
    // Quota exceeded or storage unavailable — history stays in-memory only.
  }
};
